export default __webpack_public_path__ + "static/media/redo.5cc1baa9.svg";